import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import * as comMod from '../../commonModule';
import * as Actions from '../../Actions';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import { FormControlLabel } from '@material-ui/core';

const useStyle = makeStyles({
  helpButton:{
    padding: "6px",
  }
})

export const checkConvertJido = (com) => {
  const checked = comMod.findDeepPath(
    com, 'etc.configReports.convJido', 
  )
  return checked ?checked :false;
}

export const ConvJido = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const allstate = useSelector(state=>state);
  const {com, hid, bid, stdDate, account} = allstate;
  const convJino_checked = comMod.findDeepPath(
    com, 'etc.configReports.convJido', 
  )
  const [convJido, setConvJido] = useState(convJino_checked!==undefined ?convJino_checked :false);

  const ConvCheckbox = () => {
    const handleChange = (ev) => {
      setConvJido(ev.target.checked);
    }

    return(
      <FormControlLabel
        control={
          <Checkbox
            checked={(convJido)}
            onClick={(ev) => handleChange(ev)}
            name='convCheckbox'
            color="primary"
          />
        }
        label='障害児を児童に変換し出力'
      />
    )
  }

  const RegisterButton = () => {
    const comEtc = com.etc ?com.etc :{};
    if(!comEtc.configReports) comEtc["configReports"] = {};
    const handleClick = () => {
      comEtc["configReports"]["convJido"] = convJido;
      const sendPrms = {
        ...com, hid, bid, date: stdDate,
        addiction: com.addiction,
        etc: comEtc,
      };
      dispatch(Actions.sendBrunch(sendPrms));
    }

    return(
      <Button
        variant='contained'
        name='児童変換登録ボタン'
        onClick={()=>handleClick()}
      >
        登録
      </Button>
    )
  }

  // const permission = comMod.parsePermission(account)[0][0];
  // if (permission !== 100) return null;
  return(
    <div style={{marginTop: 8}}>
      <ConvCheckbox />
      <RegisterButton />
    </div>  
  )
}